/* ============================================================
   ATELIER - "Add to Project" panel (PDP -> Project Studio filing)
   Self-contained. Ported from _bsd-atelier-project-add-harness.html
   (design approved 2026-07-05) + the v2 pass approved 2026-07-06
   (_bsd-atelier-project-add-v2-harness.html): fixture-ICON room map
   with real product thumbnails in filled slots, finish-match chips,
   PDP-quantity honouring, room subtotals, and Undo on the toast.

   Data flow:
   - click -> fetch {root}products/<handle>?section_id=atelier-project-item
     (+ &variant=<vid> when the PDP has one selected) and read the
     #psItemData JSON - the SAME resolver shared project links use,
     now also emitting the inferred Studio `slot`.
   - the current handle survives the PDP's AJAX finish swap via the
     `atelier:colour-swapped` event (detail.url = the sibling URL).
   - writes the Studio's localStorage schema (atelierWorkspace) with
     the exact addItem semantics (multi slots append, single slots
     replace keeping qty), then refreshes the header #psNavBadge.
   Maps (ROOMS/SLOT_LABEL/MULTI/IC/SLOT_IC) MIRROR
   assets/atelier-project-studio.js - update the two files together.
   ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("apaRoot");
  if (!root) return;
  var ROUTES_ROOT = root.dataset.root || "/";
  var PROJECT_URL = root.dataset.projectUrl || "/pages/project";

  /* ---------- Studio maps (mirror atelier-project-studio.js) ---------- */
  var ROOMS = {
    ensuite: { name: "Ensuite", slots: ["toilet","vanity","basin","basin-mixer","shower","shower-mixer","towel-rail","mirror","accessory"] },
    main:    { name: "Main Bathroom", slots: ["toilet","vanity","basin","basin-mixer","shower","shower-mixer","bath","towel-rail","mirror","accessory"] },
    laundry: { name: "Laundry", slots: ["laundry-sink","laundry-mixer","kitchen-accessory"] },
    kitchen: { name: "Kitchen", slots: ["sink","kitchen-mixer","kitchen-accessory"] }
  };
  var ROOM_IC = {
    ensuite: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M8 4v6"/>',
    main:    '<path d="M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M7 12V7a2 2 0 0 1 2-2 2 2 0 0 1 2 2"/>',
    laundry: '<rect x="4" y="3" width="16" height="18" rx="2"/><circle cx="12" cy="13" r="4"/><path d="M7 6h.01M10 6h.01"/>',
    kitchen: '<path d="M4 9h16v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/><path d="M8 9V5a3 3 0 0 1 6 0M17 4v5"/>'
  };
  var ROOM_DESC = {
    ensuite: "Toilet, vanity, shower and the essentials.",
    main: "The full family bathroom, bath included.",
    laundry: "Tub or sink, mixer, finishing pieces.",
    kitchen: "Sink, mixer and the finishing pieces."
  };
  var SLOT_LABEL = { toilet:"Toilet suite", vanity:"Vanity", basin:"Basin", "basin-mixer":"Basin mixer", shower:"Shower", "shower-mixer":"Shower mixer", bath:"Bath", "towel-rail":"Towel rail", mirror:"Mirror", accessory:"Accessories", sink:"Kitchen sink", "kitchen-mixer":"Kitchen mixer", "kitchen-accessory":"Sink accessories", "laundry-sink":"Laundry tub / sink", "laundry-mixer":"Laundry mixer" };
  var MULTI = { accessory: true, "kitchen-accessory": true };
  /* finish-bearing fixtures (mirror SLOTS[key].fin in atelier-project-studio.js): ONLY these carry a
     metal finish and drive coordination. Ceramic/timber/glass fixtures (toilet, vanity, basin, bath,
     mirror, sinks) never do - so they never get a match chip or a finish-clash note. */
  var FIN = { "basin-mixer": true, shower: true, "shower-mixer": true, "towel-rail": true, accessory: true, "kitchen-mixer": true, "laundry-mixer": true };

  /* fixture glyphs - copied verbatim from atelier-project-studio.js IC map (MDI filled, 24 viewBox) */
  var IC = {
    toilet:   '<path d="M9,22H17V19.5C19.41,17.87 21,15.12 21,12V4A2,2 0 0,0 19,2H15C13.89,2 13,2.9 13,4V12H3C3,15.09 5,18 9,19.5V22Z"/>',
    vanity:   '<rect x="2.6" y="8.6" width="18.8" height="2" rx="1"/><path d="M6 4.3h12a6 4.3 0 0 1-12 0z"/><path fill-rule="evenodd" d="M4.5 10.4h15a1.5 1.5 0 0 1 1.5 1.5v7.1a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-7.1a1.5 1.5 0 0 1 1.5-1.5zM11.6 12h.8v6.6h-.8zM8.5 14.7h1.4v2H8.5zM14.1 14.7h1.4v2h-1.4z"/>',
    basin:    '<path d="M22 15C22 18.9 18.9 22 15 22H9C5.1 22 2 18.9 2 15V12H22V15Z"/>',
    mixer:    '<path d="M19 14V16H16V14.28L19 14M19 13C19 11.9 18 11 16.8 11H10V10H5V21H10V13.91L19 13M5 9H10V7L15.36 5.21C15.74 5.09 16 4.73 16 4.33C16 3.68 15.36 3.23 14.75 3.45L5 7V9Z"/>',
    showermixer:'<circle cx="12" cy="10" r="5.5"/><rect x="10.8" y="14" width="2.4" height="8" rx="1.2"/>',
    shower:   '<path d="M20,20A1,1 0 0,1 21,21A1,1 0 0,1 20,22A1,1 0 0,1 19,21A1,1 0 0,1 20,20M16,20A1,1 0 0,1 17,21A1,1 0 0,1 16,22A1,1 0 0,1 15,21A1,1 0 0,1 16,20M12,20A1,1 0 0,1 13,21A1,1 0 0,1 12,22A1,1 0 0,1 11,21A1,1 0 0,1 12,20M8,20A1,1 0 0,1 9,21A1,1 0 0,1 8,22A1,1 0 0,1 7,21A1,1 0 0,1 8,20M4,20A1,1 0 0,1 5,21A1,1 0 0,1 4,22A1,1 0 0,1 3,21A1,1 0 0,1 4,20M6,17A1,1 0 0,1 7,18A1,1 0 0,1 6,19H6A1,1 0 0,1 5,18A1,1 0 0,1 6,17H6M10,17A1,1 0 0,1 11,18A1,1 0 0,1 10,19A1,1 0 0,1 9,18A1,1 0 0,1 10,17M14,17A1,1 0 0,1 15,18A1,1 0 0,1 14,19A1,1 0 0,1 13,18A1,1 0 0,1 14,17M18,17A1,1 0 0,1 19,18A1,1 0 0,1 18,19A1,1 0 0,1 17,18A1,1 0 0,1 18,17M8,14A1,1 0 0,1 9,15A1,1 0 0,1 8,16A1,1 0 0,1 7,15A1,1 0 0,1 8,14M12,14A1,1 0 0,1 13,15A1,1 0 0,1 12,16A1,1 0 0,1 11,15A1,1 0 0,1 12,14M16,14A1,1 0 0,1 17,15A1,1 0 0,1 16,16A1,1 0 0,1 15,15A1,1 0 0,1 16,14M19,12H5V10H19V12M17.92,9H6.08C6.5,6.5 8.5,4.5 11,4.08V2H13V4.08C15.5,4.5 17.5,6.5 17.92,9Z"/>',
    bath:     '<path d="M7 5C8.11 5 9 5.9 9 7S8.11 9 7 9 5 8.11 5 7 5.9 5 7 5M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.5L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.5 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10 5 11 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20Z"/>',
    towel:    '<g transform="scale(.09375)"><path d="M224 48v104a8 8 0 0 1-8.53 8a8.17 8.17 0 0 1-7.47-8.25V48a8 8 0 0 0-8.55-8a8.19 8.19 0 0 0-7.45 8.28V180a4 4 0 0 1-4 4H52a4 4 0 0 1-4-4V48a24 24 0 0 1 24-24h128a24 24 0 0 1 24 24m-36 152H52a4 4 0 0 0-4 4v12a16 16 0 0 0 16 16h112a16 16 0 0 0 16-16v-12a4 4 0 0 0-4-4"/></g>',
    mirror:   '<path d="M12 1C16.69 1 20.5 5.93 20.5 12C20.5 18.08 16.69 23 12 23C7.31 23 3.5 18.08 3.5 12C3.5 5.93 7.31 1 12 1M12 3C8.41 3 5.5 7.03 5.5 12C5.5 16.97 8.41 21 12 21C15.59 21 18.5 16.97 18.5 12C18.5 7.03 15.59 3 12 3M8.29 10.28L11.53 7.03L12.59 8.09L9.35 11.34L8.29 10.28M8.7 14.61L14.36 8.95L15.42 10L9.76 15.67L8.7 14.61Z"/>',
    accessory:'<path d="M3 5h11.5a1.1 1.1 0 0 1 0 2.2H5.2V12a1.1 1.1 0 0 1-2.2 0z"/><path fill-rule="evenodd" d="M6.2 12.5a4.6 4.6 0 1 0 9.2 0 4.6 4.6 0 1 0-9.2 0M9.2 12.5a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 1 0-3.2 0"/>',
    sink:     '<path d="M22 15C22 18.9 18.9 22 15 22H9C5.1 22 2 18.9 2 15V12H22V15Z"/>'
  };
  /* slot key -> fixture glyph (mirrors SLOTS[key].ic in the Studio) */
  var SLOT_IC = {
    toilet:IC.toilet, vanity:IC.vanity, basin:IC.basin, "basin-mixer":IC.mixer,
    shower:IC.shower, "shower-mixer":IC.showermixer, bath:IC.bath, "towel-rail":IC.towel,
    mirror:IC.mirror, accessory:IC.accessory, sink:IC.sink, "kitchen-mixer":IC.mixer,
    "kitchen-accessory":IC.accessory, "laundry-sink":IC.sink, "laundry-mixer":IC.mixer
  };
  function slotIc(s){ return SLOT_IC[s] || '<circle cx="12" cy="12" r="6"/>'; }

  /* ---------- workspace (Studio schema; mirror load()/save() semantics) ---------- */
  var WS_KEY = "atelierWorkspace", LEGACY_KEY = "atelierProject";
  function pid(){ return "p" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function loadWs(){
    var ws = null;
    try {
      var raw = localStorage.getItem(WS_KEY);
      if (raw) { var w = JSON.parse(raw); if (w && w.projects && w.projects.length) ws = w; }
      if (!ws) {
        var oldRaw = localStorage.getItem(LEGACY_KEY);
        if (oldRaw) { var d = JSON.parse(oldRaw); if (d && d.rooms && d.rooms.length) ws = { projects: [{ id: pid(), name: "My project", rooms: d.rooms, active: d.active || 0 }], active: 0 }; }
      }
    } catch (e) {}
    if (ws) {
      if (ws.active >= ws.projects.length) ws.active = 0;
      ws.projects.forEach(function (p) { if (!p.rooms) p.rooms = []; if (!p.id) p.id = pid(); if (!p.name) p.name = "My project"; });
      /* an untouched blank workspace (one empty project) counts as "no project yet" */
      var any = ws.projects.some(function (p) { return p.rooms.length; });
      if (!any && ws.projects.length === 1) return { ws: ws, blank: true };
      return { ws: ws, blank: false };
    }
    return { ws: null, blank: true };
  }
  function isBlank(w){
    if (!w) return true;
    var any = w.projects.some(function (p) { return p.rooms.length; });
    return !any && w.projects.length === 1;
  }
  function persist(w){ try { localStorage.setItem(WS_KEY, JSON.stringify(w)); } catch (e) {} }
  function updateBadge(w){
    var b = document.getElementById("psNavBadge");
    if (!b) return;
    var p = w && w.projects[w.active];
    var n = p ? p.rooms.reduce(function (a, r) { return a + (r.items || []).length; }, 0) : 0;
    if (n > 0) { b.textContent = n; b.hidden = false; } else { b.hidden = true; }
  }

  /* ---------- state ---------- */
  var curHandle = null;          // tracks the PDP product across AJAX finish swaps
  var item = null;               // resolved product data (from atelier-project-item)
  var ws = null, blank = true;   // workspace snapshot for this open
  var sel = { proj: 0, room: 0 };
  var fetchGen = 0;
  var panelQty = 1;              // honours the PDP quantity; editable in the panel
  var undoSnap = null, undoWasNull = false;   // pre-op snapshot for Undo

  /* ---------- helpers ---------- */
  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(c){ return "$" + Math.round((c || 0) / 100).toLocaleString(); }
  function clone(o){ return JSON.parse(JSON.stringify(o)); }
  function famSw(f){ return '<span class="apa-msw apa-msw--' + esc((f || "").toLowerCase().replace(/\s+/g, "-")) + '"></span>'; }
  function famOfFinish(fin){ return (fin || "").toLowerCase().replace(/\s+/g, "-"); }
  function itemsForSlot(r, slot){ return (r.items || []).filter(function (i) { return i.slot === slot; }); }
  function roomHasSlot(type, slot){ return ROOMS[type] && ROOMS[type].slots.indexOf(slot) >= 0; }
  function eligibleTypes(slot){ return Object.keys(ROOMS).filter(function (k) { return roomHasSlot(k, slot); }); }
  function roomTotal(r){ return (r.items || []).reduce(function (a, i) { return a + (i.price || 0) * (i.qty || 1); }, 0); }
  /* a finish sibling of the current product in an EXACT family match (else null) - so we only
     ever offer a real, correctly-matched alternative; imperfect sibling data just yields nothing */
  function siblingForFamily(fam){
    if (!fam || !item || !item.siblings) return null;
    for (var i = 0; i < item.siblings.length; i++) {
      var s = item.siblings[i];
      if (s && s.h && s.fam === fam) return s;
    }
    return null;
  }
  function roomAccessorySlot(type){
    var slots = (ROOMS[type] || {}).slots || [];
    for (var i = 0; i < slots.length; i++) { if (MULTI[slots[i]]) return slots[i]; }
    return null;
  }
  /* the slot this product takes in a given room type. A mapped fixture must land in
     its OWN slot - if the room doesn't have it (e.g. a toilet in a kitchen) the room is
     blocked (returns null). Only genuinely UNMAPPED products fall back to accessories. */
  function slotForRoom(type){
    if (item.slot && roomHasSlot(type, item.slot)) return item.slot;
    if (!item.slot) return roomAccessorySlot(type);
    return null;
  }
  function defaultRoom(p){
    var rs = p.rooms, first = -1;
    for (var i = 0; i < rs.length; i++) {
      var s = slotForRoom(rs[i].type);
      if (!s) continue;
      if (first < 0) first = i;
      if (MULTI[s] || !itemsForSlot(rs[i], s).length) return i;
    }
    return first;
  }
  /* read the PDP's current quantity so the panel opens with it */
  function currentQty(){
    var inp = document.querySelector(".atelier-pdp .quantity__input");
    var v = inp ? parseInt(inp.value, 10) : 1;
    return (v && v > 0) ? Math.min(v, 99) : 1;
  }
  /* ---------- project switcher cards + all-projects overlay ---------- */
  /* per-project rollup: rooms, item count, spend total, room names, finish families, budget */
  function projStats(p){
    var items = 0, total = 0, fams = [], seen = {}, budget = 0, hasBudget = false;
    (p.rooms || []).forEach(function (r) {
      (r.items || []).forEach(function (it) {
        var q = it.qty || 1; items += q; total += (it.price || 0) * q;
        if (it.family && !seen[it.family]) { seen[it.family] = 1; fams.push(it.family); }
      });
      if (r.finish) { var f = famOfFinish(r.finish); if (!seen[f]) { seen[f] = 1; fams.push(f); } }
      if (r.budget) { budget += r.budget; hasBudget = true; }   /* Studio's per-room Budget Tracker */
    });
    var names = (p.rooms || []).map(function (r) { return r.name; });
    return { rooms: (p.rooms || []).length, items: items, total: total, names: names, fams: fams, budget: budget, hasBudget: hasBudget };
  }
  /* one project card (reused inline + in the overlay) */
  function projCard(pr, i){
    var st = projStats(pr);
    var cur = (i === ws.active) ? '<span class="apa-proj-cur">Current</span>' : "";
    var roomsLine = st.rooms ? esc(st.names.join(" · ")) : "No rooms yet";
    var fins = st.fams.slice(0, 4).map(function (f) { return famSw(f); }).join("");
    var finsHtml = fins ? '<span class="apa-proj-fins">' + fins + (st.fams.length > 4 ? '<span class="apa-proj-more">+' + (st.fams.length - 4) + "</span>" : "") + "</span>" : "";
    var bits = [st.rooms + " room" + (st.rooms === 1 ? "" : "s")];
    if (st.items) bits.push(st.items + " item" + (st.items === 1 ? "" : "s"));
    if (st.total) bits.push("<b>" + money(st.total) + "</b>");
    var budgetHtml = "";
    if (st.hasBudget) {
      var diff = st.budget - st.total, cls = diff >= 0 ? "under" : "over", tail = diff >= 0 ? money(diff) + " left" : money(-diff) + " over";
      budgetHtml = '<div class="apa-proj-budget ' + cls + '">Budget ' + money(st.budget) + " &middot; " + tail + "</div>";
    }
    return '<button type="button" class="apa-proj' + (i === sel.proj ? " on" : "") + '" data-proj="' + i + '">'
      + '<div class="apa-proj-top"><span class="apa-proj-name">' + esc(pr.name) + "</span>" + cur + "</div>"
      + '<div class="apa-proj-rooms">' + roomsLine + "</div>"
      + '<div class="apa-proj-bot"><span class="apa-proj-meta">' + bits.join(" &middot; ") + "</span>" + finsHtml + "</div>"
      + budgetHtml
      + "</button>";
  }
  function openProjSheet(){
    var list = $("#apaProjSheetList"); if (!list) return;
    list.innerHTML = ws.projects.map(function (pr, i) { return projCard(pr, i); }).join("");
    $$(".apa-proj", list).forEach(function (b) { b.addEventListener("click", function () { sel.proj = +b.dataset.proj; sel.room = defaultRoom(ws.projects[sel.proj]); closeProjSheet(); render(); }); });
    var c = $("#apaProjSheetCount"); if (c) c.textContent = ws.projects.length + " projects";
    $("#apaProjSheet").classList.add("on");
  }
  function closeProjSheet(){ var s = $("#apaProjSheet"); if (s) s.classList.remove("on"); }

  /* ---------- panel chrome ---------- */
  var pa = $("#apaPanel"), scrim = $("#apaScrim"), bd = $("#apaBd");
  var lastFocus = null;
  function lockScroll(){
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if (sw > 0) document.body.style.paddingRight = sw + "px";
    document.body.style.overflow = "hidden";
  }
  function unlockScroll(){ document.body.style.overflow = ""; document.body.style.paddingRight = ""; }
  function openPanel(){
    lastFocus = document.activeElement;
    pa.classList.remove("done");
    closeProjSheet();
    scrim.classList.add("on"); pa.classList.add("on");
    lockScroll();
    var x = $("#apaX"); if (x) x.focus({ preventScroll: true });
  }
  function closePanel(){
    scrim.classList.remove("on"); pa.classList.remove("on");
    unlockScroll();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- rendering ---------- */
  /* brand loader (Hex Wave + Pop) - reuses the Studio's atelier-logo-loader snippet,
     cloned from the #apaLoaderTpl template so the loading state matches the Planner. */
  function staggerLoader(svg){
    if (!svg) return;
    var tiles = $$(".bath > *", svg); if (!tiles.length) return;
    var xs = tiles.map(function (t) { try { var b = t.getBBox(); return b.x + b.width / 2; } catch (e) { return 0; } });
    var min = Math.min.apply(null, xs), max = Math.max.apply(null, xs), r = (max - min) || 1;
    tiles.forEach(function (t, i) { t.style.animationDelay = (((xs[i] - min) / r) * 0.65).toFixed(3) + "s"; });
  }
  function renderLoader(label){
    bd.innerHTML = '<div class="apa-loaderbox"><span class="apa-loaderholder"></span>' + (label ? '<span class="apa-loader-label">' + esc(label) + "</span>" : "") + "</div>";
    $("#apaF").style.display = "none";
    var tpl = document.getElementById("apaLoaderTpl"), holder = bd.querySelector(".apa-loaderholder");
    if (tpl && tpl.content && tpl.content.firstElementChild && holder) {
      var svg = tpl.content.firstElementChild.cloneNode(true);
      holder.appendChild(svg);
      staggerLoader(svg); // svg is now in the visible DOM so getBBox works
    }
  }
  function renderError(){
    bd.innerHTML = '<div class="apa-err">Couldn\'t load this product\'s details. Check your connection and try again.</div>';
    $("#apaF").style.display = "none";
  }
  function prodCard(){
    return '<div class="apa-prod"><span class="im"><img src="' + esc(item.img) + '" alt="" loading="lazy"></span>'
      + '<span class="nm"><b>' + esc(item.title) + "</b>"
      + (item.finish ? '<span class="fin">' + famSw(item.family) + esc(item.finish) + "</span>" : "")
      + '</span><span class="pr">' + money(item.price) + "</span></div>";
  }
  function qtyRow(){
    return '<div class="apa-qtyrow"><span class="lbl">Quantity'
      + '<span class="tot" id="apaQtyTot">' + (panelQty > 1 ? money(item.price * panelQty) : "") + '</span></span>'
      + '<span class="apa-qty"><button type="button" id="apaQm"' + (panelQty <= 1 ? " disabled" : "") + '>&minus;</button>'
      + '<span id="apaQtyN">' + panelQty + '</span><button type="button" id="apaQp">+</button></span></div>';
  }
  function typeGrid(){
    var slot = item.slot || "accessory";
    return '<div class="apa-types">' + eligibleTypes(slot).map(function (k) {
      return '<button type="button" class="apa-type" data-newtype="' + k + '"><svg viewBox="0 0 24 24" aria-hidden="true">' + ROOM_IC[k] + "</svg><b>" + ROOMS[k].name + "</b><span>" + ROOM_DESC[k] + "</span></button>";
    }).join("") + "</div>";
  }
  function render(){
    var html = prodCard() + qtyRow();

    if (blank) {
      /* first visit (or an untouched blank project): one tap = room + filed */
      html += '<div class="apa-lab">Start your project - pick a room</div>' + typeGrid();
      html += '<div class="apa-slotline"><span class="si"><svg viewBox="0 0 24 24"><path d="M3 7h7l2 2h9v9a2 2 0 0 1-2 2H3z"/></svg></span>'
        + "<span>This starts <b>My project</b> on this device and files the piece under <b>" + esc(SLOT_LABEL[item.slot || "accessory"] || "Accessories") + "</b>. No account needed.</span></div>";
      bd.innerHTML = html;
      $("#apaF").style.display = "none";
      wireQty();
      $$(".apa-type", bd).forEach(function (b) { b.addEventListener("click", function () { confirmAdd(b.dataset.newtype); }); });
      return;
    }

    var p = ws.projects[sel.proj];

    if (ws.projects.length > 1) {
      /* show only the SELECTED project inline (keeps the panel short so the room list +
         finish-mismatch note stay above the fold); the rest live in the overlay */
      html += '<div class="apa-lab">Project</div><div class="apa-projrow">'
        + projCard(ws.projects[sel.proj], sel.proj)
        + '<button type="button" class="apa-proj-all" id="apaProjAll">See all ' + ws.projects.length + ' projects<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>'
        + "</div>";
    }

    html += '<div class="apa-lab">Which room?</div>';
    /* explainer - names what the fixture row means + echoes the target glyph */
    html += '<div class="apa-hint"><div class="hlead">Each row is the room’s fixtures - filled, open, or your piece’s spot.</div>'
      + '<div class="tgt"><span class="tg"><svg viewBox="0 0 24 24">' + slotIc(item.slot || "accessory") + '</svg></span>'
      + '<span>Your piece drops into the highlighted <b>' + esc(SLOT_LABEL[item.slot || "accessory"] || "Accessories") + '</b> slot.</span></div></div>';

    html += '<div class="apa-rooms">';
    p.rooms.forEach(function (r, i) {
      var slot = slotForRoom(r.type);
      if (!slot) {
        html += '<div class="apa-room off"><span class="apa-rtop"><span class="ric"><svg viewBox="0 0 24 24" aria-hidden="true">' + (ROOM_IC[r.type] || "") + "</svg></span>"
          + '<span class="rmid"><span class="rnm">' + esc(r.name) + '</span><span class="rmeta">No ' + esc((SLOT_LABEL[item.slot] || "matching").toLowerCase()) + " slot in a " + esc((ROOMS[r.type] || { name: r.type }).name.toLowerCase()) + "</span></span></span></div>";
        return;
      }
      var slots = ROOMS[r.type] ? ROOMS[r.type].slots : [];
      var nSlots = slots.length;
      var cols = nSlots <= 5 ? nSlots : Math.ceil(nSlots / 2);
      var few = nSlots <= 5;
      /* fixture map - filled slots show the real product image, empty show the ghost glyph */
      var map = slots.map(function (s) {
        var its = itemsForSlot(r, s), filled = its.length > 0, isTgt = (s === slot);
        var cls = "apa-mtile", badge = "";
        var img = filled ? (its[0].img || "") : "";
        var inner = img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<svg viewBox="0 0 24 24">' + slotIc(s) + '</svg>';
        if (img) cls += " prod";
        if (isTgt) {
          cls += filled ? " tgt fill" : " tgt";
          if (!MULTI[slot] && filled) badge = '<span class="mb"><svg viewBox="0 0 24 24"><path d="M17 3l4 4-4 4M21 7H9M7 21l-4-4 4-4M3 17h12"/></svg></span>';
          else badge = '<span class="mb">+</span>';
        } else if (filled) {
          cls += " fill";
          if (MULTI[s] && its.length > 1) badge = '<span class="mb ct">' + its.length + '</span>';
        } else { cls += " empty"; }
        return '<span class="' + cls + '" title="' + esc(SLOT_LABEL[s] + (filled ? " - " + (its[0].title || "filled") : " - open")) + '">' + inner + badge + '</span>';
      }).join("");
      /* finish coordination: a quiet green "Matches" chip when coordinated; a clear amber note
         INSIDE the card when it clashes (the warning belongs to the room + stays visible with it,
         not stranded below the list). Only for finish-bearing fixtures with a family. */
      var chip = "", clashNote = "", swapBtn = "";
      if (FIN[item.slot] && item.family && r.finish) {
        if (famOfFinish(r.finish) === item.family) {
          chip = '<span class="apa-fchip ok">Matches</span>';
        } else {
          clashNote = '<span class="apa-roomwarn"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 9v4M12 17h.01"/><circle cx="12" cy="12" r="9"/></svg>'
            + '<span>This room is set to <b>' + esc(r.finish) + '</b> - this piece is <b>' + esc(item.finish) + '</b></span></span>';
          /* if this exact piece exists in the room's finish, offer to swap the panel to it */
          var sib = siblingForFamily(famOfFinish(r.finish));
          if (sib) swapBtn = '<button type="button" class="apa-roomswap" data-swap="' + esc(sib.h) + '" data-swaproom="' + i + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17 3l4 4-4 4M21 7H9M7 21l-4-4 4-4M3 17h12"/></svg>Use the ' + esc(sib.fin) + ' version of this piece</button>';
        }
      }
      var filledCount = slots.filter(function (s) { return itemsForSlot(r, s).length; }).length;
      var tot = roomTotal(r);
      var meta = filledCount + " of " + nSlots + " fixtures" + (tot ? " &middot; <b>" + money(tot) + "</b>" : "");

      var cardHtml = '<button type="button" class="apa-room' + (i === sel.room ? " on" : "") + '" data-room="' + i + '">'
        + '<span class="apa-rtop"><span class="ric"><svg viewBox="0 0 24 24" aria-hidden="true">' + (ROOM_IC[r.type] || "") + "</svg></span>"
        + '<span class="rmid"><span class="rnm">' + esc(r.name) + (r.finish ? famSw(famOfFinish(r.finish)) : "") + chip + "</span>"
        + '<span class="rmeta">' + meta + "</span></span>"
        + '<span class="sel"></span></span>'
        + '<span class="apa-map' + (few ? " apa-map--few" : "") + '" style="--cols:' + cols + '">' + map + "</span>"
        + roomNote(r, slot)
        + clashNote
        + "</button>";
      /* the swap button is a sibling of the room button (not nested) inside a wrap, so it groups
         with the card without invalid button-in-button markup */
      html += swapBtn ? ('<div class="apa-roomwrap">' + cardHtml + swapBtn + "</div>") : cardHtml;
    });
    html += '<button type="button" class="apa-newroom" id="apaNew"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>New room</button></div>';

    /* new-room type grid, revealed on request (or immediately when no room fits) */
    var noFit = sel.room < 0;
    html += '<div id="apaNewTypes"' + (noFit ? "" : ' style="display:none"') + '><div class="apa-lab">What kind of room?</div>' + typeGrid() + "</div>";
    html += '<div id="apaStatus"></div>';

    bd.innerHTML = html;
    $("#apaF").style.display = noFit ? "none" : "";

    wireQty();
    $$(".apa-proj", bd).forEach(function (b) { b.addEventListener("click", function () { sel.proj = +b.dataset.proj; sel.room = defaultRoom(ws.projects[sel.proj]); render(); }); });
    var pAll = $("#apaProjAll", bd); if (pAll) pAll.addEventListener("click", openProjSheet);
    $$(".apa-room[data-room]", bd).forEach(function (b) { b.addEventListener("click", function () { sel.room = +b.dataset.room; render(); }); });
    $$(".apa-roomswap", bd).forEach(function (b) { b.addEventListener("click", function () { swapProduct(b.dataset.swap, +b.dataset.swaproom); }); });
    var nb = $("#apaNew", bd);
    if (nb) nb.addEventListener("click", function () { $("#apaNewTypes").style.display = ""; nb.style.display = "none"; });
    $$("#apaNewTypes .apa-type", bd).forEach(function (b) { b.addEventListener("click", function () { confirmAdd(b.dataset.newtype); }); });

    renderStatus();
  }

  /* qty stepper wiring (shared by both render paths) */
  function wireQty(){
    var m = $("#apaQm"), p = $("#apaQp");
    if (m) m.addEventListener("click", function () { if (panelQty > 1) { panelQty--; updateQtyUI(); } });
    if (p) p.addEventListener("click", function () { if (panelQty < 99) { panelQty++; updateQtyUI(); } });
  }
  function updateQtyUI(){
    var n = $("#apaQtyN"); if (n) n.textContent = panelQty;
    var t = $("#apaQtyTot"); if (t) t.textContent = panelQty > 1 ? money(item.price * panelQty) : "";
    var m = $("#apaQm"); if (m) m.disabled = panelQty <= 1;
    var r = (ws && ws.projects[sel.proj]) ? ws.projects[sel.proj].rooms[sel.room] : null;
    var g = $("#apaGoTx"); if (g && r) g.textContent = (panelQty > 1 ? "Add " + panelQty + " to " : "Add to ") + r.name;
  }

  /* a room's placement note - lives IN the room card now: replace the incumbent / join
     accessories. Empty slots need nothing (the fixture map + hint already show the open target). */
  function roomNote(r, slot){
    var occ = itemsForSlot(r, slot);
    if (MULTI[slot]) {
      if (!occ.length) return "";
      return '<span class="apa-roomnote"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>Joins <b>' + occ.length + '</b> other accessor' + (occ.length === 1 ? "y" : "ies") + ' in this room</span></span>';
    }
    if (occ.length) {
      var inc = occ[0];
      return '<span class="apa-roomnote rep"><span class="rt"><img src="' + esc(inc.img || item.img) + '" alt="" loading="lazy"></span>'
        + '<span><b>Replaces</b> ' + esc(inc.title || "the current piece") + (inc.price ? " &middot; " + money(inc.price) : "") + '</span></span>';
    }
    return "";
  }
  /* placement + finish now live inside the room cards; the status box only drives the CTA label */
  function renderStatus(){
    var box = $("#apaStatus"); if (box) box.innerHTML = "";
    if (sel.room < 0) return;
    var p = ws.projects[sel.proj], r = p.rooms[sel.room];
    if (!r) return;
    $("#apaGoTx").textContent = (panelQty > 1 ? "Add " + panelQty + " to " : "Add to ") + r.name;
  }

  /* ---------- the add ---------- */
  function confirmAdd(newType){
    /* snapshot the workspace BEFORE mutating so Undo can revert exactly */
    undoWasNull = !ws;
    undoSnap = ws ? clone(ws) : null;

    if (!ws) { ws = { projects: [{ id: pid(), name: "My project", rooms: [], active: 0 }], active: 0 }; sel.proj = 0; }
    var p = ws.projects[sel.proj];
    if (newType) {
      p.rooms.push({ type: newType, name: ROOMS[newType].name, items: [], finish: null });
      sel.room = p.rooms.length - 1;
      p.active = sel.room;
    }
    var r = p.rooms[sel.room];
    if (!r) return;
    var slot = slotForRoom(r.type);
    if (!slot) return;

    /* Studio addItem semantics: multi appends; single replaces. Qty from the panel/PDP. */
    var snap = { slot: slot, handle: item.handle, title: item.title, brand: item.brand, price: item.price, compare: item.compare || 0, img: item.img, finish: item.finish || "", family: item.family || "", vid: item.vid, qty: panelQty, url: item.url || (ROUTES_ROOT + "products/" + item.handle) };
    if (MULTI[slot]) { r.items.push(snap); }
    else {
      var ex = itemsForSlot(r, slot);
      if (ex.length) { r.items[r.items.indexOf(ex[0])] = snap; }
      else r.items.push(snap);
    }
    ws.active = sel.proj;
    persist(ws);
    updateBadge(ws);

    var qtyTxt = panelQty > 1 ? panelQty + " × " : "";
    $("#apaDoneTitle").textContent = "Added to " + r.name;
    $("#apaDoneSub").innerHTML = "Filed under <b>" + esc(SLOT_LABEL[slot]) + "</b> in " + esc(p.name) + ".";
    $("#apaDoneImg").src = item.img || "";
    $("#apaDoneMeta").innerHTML = "<b>" + esc(item.title) + "</b><br>" + esc(item.finish ? item.finish + " · " : "") + qtyTxt + money(item.price) + (panelQty > 1 ? " (" + money(item.price * panelQty) + ")" : "");
    pa.classList.add("done");
    toast("<b>" + esc((item.title || "Item").split(",")[0]) + "</b> added to " + esc(r.name), "Undo", doUndo);
  }

  /* undo the last filing: restore the pre-op workspace, return to the board */
  function doUndo(){
    ws = undoWasNull ? null : clone(undoSnap);
    blank = isBlank(ws);
    if (ws) {
      if (sel.proj >= ws.projects.length) sel.proj = ws.active || 0;
      sel.room = defaultRoom(ws.projects[sel.proj]);
      persist(ws);
    } else {
      sel = { proj: 0, room: 0 };
      try { localStorage.removeItem(WS_KEY); } catch (e) {}
    }
    updateBadge(ws);
    pa.classList.remove("done");
    render();
    toast("Removed - nothing filed");
  }

  /* ---------- open flow (fetch -> render) ---------- */
  function currentVid(){
    var inp = document.querySelector(".atelier-pdp .product-variant-id");
    return inp && inp.value ? inp.value : null;
  }
  function openFor(handle){
    openPanel();
    panelQty = currentQty();
    renderLoader("Getting things ready");
    var gen = ++fetchGen;
    var url = ROUTES_ROOT + "products/" + handle + "?section_id=atelier-project-item";
    var vid = currentVid();
    if (vid) url += "&variant=" + encodeURIComponent(vid);
    fetch(url)
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (htmlTx) {
        if (gen !== fetchGen) return;
        var doc = new DOMParser().parseFromString(htmlTx, "text/html");
        var node = doc.getElementById("psItemData");
        if (!node) throw new Error("no data");
        item = JSON.parse(node.textContent);
        var state = loadWs();
        ws = state.ws; blank = state.blank;
        if (!blank) { sel.proj = ws.active || 0; sel.room = defaultRoom(ws.projects[sel.proj]); }
        render();
      })
      .catch(function () { if (gen === fetchGen) renderError(); });
  }
  /* swap the panel's product to a finish sibling in place (keeps project + room + qty). Reuses the
     resolver fetch; a failed/stale fetch leaves the current product untouched (never breaks the panel). */
  function swapProduct(handle, roomIdx){
    var gen = ++fetchGen;
    fetch(ROUTES_ROOT + "products/" + handle + "?section_id=atelier-project-item")
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (htmlTx) {
        if (gen !== fetchGen) return;
        var node = new DOMParser().parseFromString(htmlTx, "text/html").getElementById("psItemData");
        if (!node) throw new Error("no data");
        item = JSON.parse(node.textContent);
        /* NB: do NOT touch curHandle - it tracks the PDP's OWN product, so reopening the panel
           resolves the piece the shopper is actually looking at, not this session's swap. */
        if (typeof roomIdx === "number" && roomIdx >= 0) sel.room = roomIdx;
        render();
        flashProd();  /* highlight the product card so the swap is obvious */
        toast("Now adding the <b>" + esc(item.finish) + "</b> version");
      })
      .catch(function () { if (gen === fetchGen) toast("Couldn't load that finish"); });
  }
  /* brief highlight on the product card after a swap (its title/finish/price/image change) */
  function flashProd(){
    var pc = $(".apa-prod", bd);
    if (!pc) return;
    pc.classList.remove("apa-prod--flash");
    void pc.offsetWidth;   // restart the animation
    pc.classList.add("apa-prod--flash");
  }

  /* ---------- toast (with optional action) ---------- */
  var toastTimer = null;
  function toast(html, actionLabel, actionCb){
    var t = $("#apaToast");
    if (!t) return;
    t.innerHTML = '<span>' + html + '</span>' + (actionLabel ? '<button type="button" class="apa-toast-act" id="apaToastAct">' + esc(actionLabel) + '</button>' : "");
    t.classList.add("on");
    if (actionLabel) { var b = $("#apaToastAct"); if (b) b.addEventListener("click", function () { t.classList.remove("on"); if (actionCb) actionCb(); }); }
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("on"); }, actionLabel ? 5200 : 2600);
  }

  /* ---------- wiring ---------- */
  /* delegated: survives anything the PDP swap does around the button */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-apg-add-to-project]") : null;
    if (!btn) return;
    e.preventDefault();
    var h = curHandle || btn.dataset.productHandle;
    if (h) openFor(h);
  });
  /* the AJAX finish swap navigates the PDP to a sibling without a reload */
  document.addEventListener("atelier:colour-swapped", function (e) {
    try {
      var u = new URL(e.detail.url, location.origin);
      var m = u.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) curHandle = m[1];
    } catch (err) {}
  });

  $("#apaX").addEventListener("click", closePanel);
  $("#apaKeep").addEventListener("click", closePanel);
  scrim.addEventListener("click", closePanel);
  var psx = $("#apaProjSheetX"); if (psx) psx.addEventListener("click", closeProjSheet);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !pa.classList.contains("on")) return;
    var s = $("#apaProjSheet");
    if (s && s.classList.contains("on")) closeProjSheet(); else closePanel();
  });
  $("#apaGo").addEventListener("click", function () { confirmAdd(null); });
})();
